webpackJsonp([114276838955818],{

/***/ 174:
/***/ (function(module, exports) {

	module.exports = {"data":{"allBicenturyTranslations":{"edges":[{"node":{"lang":"es","cookielayer_title":"ACEPTA LAS COOKIES, AUNQUE DONDE SE PONGAN UNAS TORTITAS...","btnBack":"Volver","gustazos":"Gustazos","products":"Productos","company":"Empresa","contact":"Contacto","legal":"Nota legal","collaborate":"Colaboramos con AEDN","allFlavors":"Todos los sabores","followus":"¡Síguenos!","menu":"Menú","languages":"Idiomas","attitude_title":" ","attitude_text":" ","attitude_hashtags":" ","btnAccept":"Acepto","id":"Bicentury__Translations__translations-es","cookielayer_text":"Cuando navegues por nuestro sitio web, las páginas pueden utilizar cookies que se colocan en tu navegador desde tu ordenador, móvil o tablet. En esta página utilizamos cookies propias y de terceros necesarias para el buen funcionamiento de nuestro sitio web y con finalidades analíticas. Clica [AQUÍ](#cookieLayerLink) para obtener más información. También puedes configurar tus preferencias o rechazar el uso de cookies.","cookielayer_acceptall":"Acepto","cookielayer_reject":"No, gracias","cookielayer_configure":"Configurar cookies","cookiecp_title":"POLÍTICA DE COOKIES","cookiecp_text":"Mediante la presente Política, NUTRITION & SANTÉ IBERIA, S.L. (en adelante, “N&S”) pretende informarle de manera clara y precisa sobre las cookies que utilizamos, detallando, a continuación, qué es una cookie, para qué sirve, qué tipos de cookies utilizamos, cuál es su finalidad, cómo puede configurarlas o deshabilitarlas si así lo desea, así como otra información necesaria.","cookiecp_firsts_paragraphs":[{"title":"1.- ¿QUÉ ES UNA COOKIE Y PARA QUÉ SIRVE?","text":"Una cookie es un pequeño archivo que se descarga en su ordenador, teléfono móvil u otro dispositivo de acceso cuando visita una determinada página web. Las cookies permiten, entre otras cosas, almacenar y recuperar información sobre los hábitos de navegación de un usuario o de su equipo y, dependiendo de la información que contengan y de la forma en que utilice su equipo, pueden utilizarse para reconocer al usuario.\r\n\r\n\r\nLas cookies pueden ser de “sesión” (se borran una vez el usuario abandona la página web que las generó) o “persistentes” (permanecen en su dispositivo hasta una fecha determinada). Asimismo, las hay “propias” (aquellas creadas y gestionadas por el responsable de la página web, en este caso, N&S) o de “terceros” (aquellas administradas por proveedores de servicios ajenos a N&S).\r\n"},{"title":"2.- ¿QUÉ TIPOS DE COOKIES UTILIZAMOS?","text":"A continuación, encontrará un listado de los tipos de cookies propias y de cookies de terceros que utilizamos en este sitio web. Podrá aceptarlas o rechazarlas marcando o desmarcando la casilla situada junto a las tipologías de cookies que requieren su consentimiento. Usted podrá, en cualquier momento, modificar la configuración señalada.  "}],"cookiecp_own_title":"COOKIES PROPIAS","cookiecp_own_text":"Este sitio web utiliza cookies propias que, a su vez, son de sesión y persistentes. Las finalidades de dichas cookies son las siguientes:","cookiecp_tech_title":"Cookies técnicas","cookiecp_tech_text":"Son necesarias para la navegación y el buen funcionamiento de nuestra página web. Permiten, por ejemplo, controlar el tráfico y la comunicación de datos o utilizar elementos de seguridad.","cookiecp_third_title":"COOKIES DE TERCEROS","cookiecp_third_text":"Este sitio web utiliza cookies de terceros que, a su vez, son de sesión y persistentes. Estas son las finalidades de dichas cookies y los terceros que pueden configurarlas y acceder a las mismas:","cookiecp_analytics_title":"Cookies de análisis.","cookiecp_analytics_text":"Permiten el seguimiento y análisis del comportamiento de los usuarios de la web. Nosotros, como editor de este sitio web, utilizamos este tipo de cookies únicamente con el fin de medir la actividad del sitio web y, en función de los resultados extraídos, introducir mejoras en los servicios y productos que ofrecemos. No obstante, Google puede utilizarlas para otras finalidades. Consulte la Política de Privacidad y la Política de Cookies de Google para más información al respecto. Para evitar que Google utilice sus datos, pincha [AQUÍ](https://tools.google.com/dlpage/gaoptout?hl=es.).","cookiecp_analytics_name":"Google Analytics (Google)","cookiecp_last_paragraphs":[{"title":"3.- CONFIGURACIÓN DEL USUARIO PARA EVITAR COOKIES:","text":"Ud. también puede revocar su consentimiento para el uso de las cookies y desactivar o eliminar las cookies instaladas en su dispositivo mediante la configuración de las opciones del navegador que esté utilizando al visitar el sitio web. Asimismo, Ud. puede activar:\r\n\r\nLa navegación privada, mediante la cual su navegador deja de guardar el historial de navegación, contraseñas de sitios web, cookies y otra información de las páginas que visita, o\r\n\r\nLa función de no rastrear, por la que el navegador pide a los sitios web que visita que no rastreen sus hábitos de navegación para, por ejemplo, servirle publicidad de su interés en los sitios que visita.\r\n\r\n\r\nA continuación le facilitamos los enlaces a los sitios de soporte oficiales de los principales navegadores para que Ud. acceder a los mismos y pueda configurar el uso de las cookies:\r\n\r\n[Microsoft Internet Explorer](https://support.microsoft.com/es-es/help/17442/windows-internet-explorer-delete-manage-cookies)\\\r\n[Mozilla Firefox](https://support.mozilla.org/es/kb/impedir-que-los-sitios-web-guarden-sus-preferencia)\\\r\n[Google Chrome](https://support.google.com/chrome/answer/95647?co=GENIE.Platform=Desktop&&hl=es)\\\r\n[Google Analytics](https://tools.google.com/dlpage/gaoptout?hl=es.)\\\r\n[Safari](https://support.apple.com/es-es/HT201265)\\\r\n\\\r\nLos enlaces anteriores pueden actualizarse por parte de las empresas desarrolladoras de dichos navegadores. En el caso de que alguno de los links facilitados no funcionara o no estuviera actualizado, puede acudir al menú “Ayuda” de su navegador y seguir los pasos que en el mismo se indique. Asimismo, si desea tener un mayor control sobre la instalación de cookies, puede instalar en su dispositivo programas o complementos a su navegador, conocidos como herramientas de “Do Not Track”, que le permitirán escoger aquellas cookies que desea permitir.\r\n\r\nSin perjuicio de lo anterior, Ud. debe tener en cuenta que si se desactivan determinadas cookies, puede que la navegación por el sitio web no sea óptima y que algunas de las utilidades de que dispone el sitio web no funcionen correctamente.\r\n"},{"title":"4.- TRATAMIENTO DE DATOS DE CARÁCTER PERSONAL A TRAVÉS DE LAS COOKIES","text":"**4.1- Responsable del Tratamiento**\r\n\r\nEl responsable del tratamiento del uso de las cookies realizado en este sitio web es:\r\n\r\nNUTRITION & SANTÉ IBERIA, S.L\\\r\nN.I.F: B-63175715. Dirección: Paseo de Gracia, nº 11, escalera B, 1ª planta, 08007, Barcelona.\\\r\nTeléfono: 900373550\\\r\nCorreo electrónico: protecciondedatos@ns-group.com.\\\r\n\\\r\nNo obstante, NUTRITION & SANTÉ IBERIA, S.L. no es responsable del uso realizado por parte de terceros. \r\n\r\n\r\n**4.2. Transferencias a terceros países**\r\n\r\nEl tratamiento de los datos se realiza, con carácter general, por prestadores de servicios ubicados dentro del Espacio Económico Europeo o en países que han sido declarados con un nivel adecuado de protección.\r\n\r\nEn otros supuestos NUTRITION & SANTÉ IBERIA, S.L. garantiza la seguridad y legitimidad del tratamiento de los datos exigiendo a sus proveedores que dispongan de normas corporativas vinculantes que garanticen la protección de la información de manera similar a las que establecen las normas europeas, que se encuentren acogidos al Privacy Shield, en caso de prestadores de servicios en los EE.UU., o que suscriban las cláusulas tipo de la Unión Europea.\r\n\r\n**4.3. Periodos de conservación de los datos**\r\n\r\nLos datos serán tratados mientras permanezcan vigentes las autorizaciones de uso otorgadas. Posteriormente, estos datos serán conservados debidamente bloqueados durante el plazo de prescripción de las acciones derivadas de dicha autorización para la formulación, ejercicio o defensa de reclamaciones.\r\n\r\nAsimismo, le informamos de que tomaremos todas las medidas razonables para garantizar que sus datos se rectifiquen o supriman cuando sean inexactos.\r\n\r\n**4.4. Más información**\r\n\r\nConsulte nuestra [Política de Privacidad](/es/politica-de-privacidad) para más información sobre el tratamiento de sus datos personales. \r\n\r\n\r\n"},{"title":"5.- ACTUALIZACIONES Y CAMBIOS EN LA POLÍTICA DE COOKIES","text":"Le informamos de que nuestra Política de Cookies se podrá modificar en cualquier momento (sobre todo teniendo en cuenta nuevas exigencias legislativas, reglamentarias o con el objetivo de adaptar dicha política a las instrucciones dictadas por la Agencia Española de Protección de Datos). Cuando se produzcan cambios significativos en esta Política de Cookies se comunicará al usuario mediante un aviso informativo en la página web."}]}},{"node":{"lang":"pt","cookielayer_title":"ACEITE OS COOKIES, MESMO QUE SEJAM UMAS TOSTITAS...","btnBack":"Volver","gustazos":"Gustazos","products":"Produtos","company":"Empresa","contact":"Contacto","legal":"Nota legal","collaborate":"Colaboramos con AEDN","allFlavors":"Todos los sabores","followus":"Segue-nos!","menu":"Menú","languages":"Idiomas","attitude_title":" ","attitude_text":" ","attitude_hashtags":" ","btnAccept":"Acepto","id":"Bicentury__Translations__translations-pt","cookielayer_text":"Quando navega no nosso site, as páginas podem utilizar cookies que são colocados no seu navegador a partir do seu computador, telemóvel ou tablet. Nesta página utilizamos cookies próprios e de terceiros necessários para o bom funcionamento do nosso site e para fins analíticos. Clique [AQUÍ](#cookieLayerLink) para obter mais informações. Também pode configurar as suas preferências ou recusar a utilização de cookies.","cookielayer_acceptall":"Aceito","cookielayer_reject":"Não, obrigado","cookielayer_configure":"Configurar cookies","cookiecp_title":"POLÍTICA DE COOKIES","cookiecp_text":"Mediante la presente Política, NUTRITION & SANTÉ IBERIA, S.L. (en adelante, “N&S”) pretende informarle de manera clara y precisa sobre las cookies que utilizamos, detallando, a continuación, qué es una cookie, para qué sirve, qué tipos de cookies utilizamos, cuál es su finalidad, cómo puede configurarlas o deshabilitarlas si así lo desea, así como otra información necesaria.","cookiecp_firsts_paragraphs":[{"title":"1.- ¿QUÉ ES UNA COOKIE Y PARA QUÉ SIRVE?","text":"Una cookie es un pequeño archivo que se descarga en su ordenador, teléfono móvil u otro dispositivo de acceso cuando visita una determinada página web. Las cookies permiten, entre otras cosas, almacenar y recuperar información sobre los hábitos de navegación de un usuario o de su equipo y, dependiendo de la información que contengan y de la forma en que utilice su equipo, pueden utilizarse para reconocer al usuario.\r\n\r\n\r\nLas cookies pueden ser de “sesión” (se borran una vez el usuario abandona la página web que las generó) o “persistentes” (permanecen en su dispositivo hasta una fecha determinada). Asimismo, las hay “propias” (aquellas creadas y gestionadas por el responsable de la página web, en este caso, N&S) o de “terceros” (aquellas administradas por proveedores de servicios ajenos a N&S).\r\n"},{"title":"2.- ¿QUÉ TIPOS DE COOKIES UTILIZAMOS?","text":"A continuación, encontrará un listado de los tipos de cookies propias y de cookies de terceros que utilizamos en este sitio web. Podrá aceptarlas o rechazarlas marcando o desmarcando la casilla situada junto a las tipologías de cookies que requieren su consentimiento. Usted podrá, en cualquier momento, modificar la configuración señalada.  "}],"cookiecp_own_title":"COOKIES PROPIAS","cookiecp_own_text":"Este sitio web utiliza cookies propias que, a su vez, son de sesión y persistentes. Las finalidades de dichas cookies son las siguientes:","cookiecp_tech_title":"Cookies técnicas","cookiecp_tech_text":"Son necesarias para la navegación y el buen funcionamiento de nuestra página web. Permiten, por ejemplo, controlar el tráfico y la comunicación de datos o utilizar elementos de seguridad.","cookiecp_third_title":"COOKIES DE TERCEROS","cookiecp_third_text":"Este sitio web utiliza cookies de terceros que, a su vez, son de sesión y persistentes. Estas son las finalidades de dichas cookies y los terceros que pueden configurarlas y acceder a las mismas:","cookiecp_analytics_title":"Cookies de análisis.","cookiecp_analytics_text":"Permiten el seguimiento y análisis del comportamiento de los usuarios de la web. Nosotros, como editor de este sitio web, utilizamos este tipo de cookies únicamente con el fin de medir la actividad del sitio web y, en función de los resultados extraídos, introducir mejoras en los servicios y productos que ofrecemos. No obstante, Google puede utilizarlas para otras finalidades. Consulte la Política de Privacidad y la Política de Cookies de Google para más información al respecto. Para evitar que Google utilice sus datos, pincha [AQUÍ](https://tools.google.com/dlpage/gaoptout?hl=es.).","cookiecp_analytics_name":"Google Analytics (Google)","cookiecp_last_paragraphs":[{"title":"3.- CONFIGURACIÓN DEL USUARIO PARA EVITAR COOKIES:","text":"Ud. también puede revocar su consentimiento para el uso de las cookies y desactivar o eliminar las cookies instaladas en su dispositivo mediante la configuración de las opciones del navegador que esté utilizando al visitar el sitio web. Asimismo, Ud. puede activar:\r\n\r\nLa navegación privada, mediante la cual su navegador deja de guardar el historial de navegación, contraseñas de sitios web, cookies y otra información de las páginas que visita, o\r\n\r\nLa función de no rastrear, por la que el navegador pide a los sitios web que visita que no rastreen sus hábitos de navegación para, por ejemplo, servirle publicidad de su interés en los sitios que visita.\r\n\r\n\r\nA continuación le facilitamos los enlaces a los sitios de soporte oficiales de los principales navegadores para que Ud. acceder a los mismos y pueda configurar el uso de las cookies:\r\n\r\n[Microsoft Internet Explorer](https://support.microsoft.com/es-es/help/17442/windows-internet-explorer-delete-manage-cookies)\\\r\n[Mozilla Firefox](https://support.mozilla.org/es/kb/impedir-que-los-sitios-web-guarden-sus-preferencia)\\\r\n[Google Chrome](https://support.google.com/chrome/answer/95647?co=GENIE.Platform=Desktop&&hl=es)\\\r\n[Google Analytics](https://tools.google.com/dlpage/gaoptout?hl=es.)\\\r\n[Safari](https://support.apple.com/es-es/HT201265)\\\r\n\\\r\nLos enlaces anteriores pueden actualizarse por parte de las empresas desarrolladoras de dichos navegadores. En el caso de que alguno de los links facilitados no funcionara o no estuviera actualizado, puede acudir al menú “Ayuda” de su navegador y seguir los pasos que en el mismo se indique. Asimismo, si desea tener un mayor control sobre la instalación de cookies, puede instalar en su dispositivo programas o complementos a su navegador, conocidos como herramientas de “Do Not Track”, que le permitirán escoger aquellas cookies que desea permitir.\r\n\r\nSin perjuicio de lo anterior, Ud. debe tener en cuenta que si se desactivan determinadas cookies, puede que la navegación por el sitio web no sea óptima y que algunas de las utilidades de que dispone el sitio web no funcionen correctamente.\r\n"},{"title":"4.- TRATAMIENTO DE DATOS DE CARÁCTER PERSONAL A TRAVÉS DE LAS COOKIES","text":"**4.1- Responsable del Tratamiento**\r\n\r\nEl responsable del tratamiento del uso de las cookies realizado en este sitio web es:\r\n\r\nNUTRITION & SANTÉ IBERIA, S.L\\\r\nN.I.F: B-63175715. Dirección: Paseo de Gracia, nº 11, escalera B, 1ª planta, 08007, Barcelona.\\\r\nTeléfono: 900373550\\\r\nCorreo electrónico: protecciondedatos@ns-group.com.\\\r\n\\\r\nNo obstante, NUTRITION & SANTÉ IBERIA, S.L. no es responsable del uso realizado por parte de terceros. \r\n\r\n\r\n**4.2. Transferencias a terceros países**\r\n\r\nEl tratamiento de los datos se realiza, con carácter general, por prestadores de servicios ubicados dentro del Espacio Económico Europeo o en países que han sido declarados con un nivel adecuado de protección.\r\n\r\nEn otros supuestos NUTRITION & SANTÉ IBERIA, S.L. garantiza la seguridad y legitimidad del tratamiento de los datos exigiendo a sus proveedores que dispongan de normas corporativas vinculantes que garanticen la protección de la información de manera similar a las que establecen las normas europeas, que se encuentren acogidos al Privacy Shield, en caso de prestadores de servicios en los EE.UU., o que suscriban las cláusulas tipo de la Unión Europea.\r\n\r\n**4.3. Periodos de conservación de los datos**\r\n\r\nLos datos serán tratados mientras permanezcan vigentes las autorizaciones de uso otorgadas. Posteriormente, estos datos serán conservados debidamente bloqueados durante el plazo de prescripción de las acciones derivadas de dicha autorización para la formulación, ejercicio o defensa de reclamaciones.\r\n\r\nAsimismo, le informamos de que tomaremos todas las medidas razonables para garantizar que sus datos se rectifiquen o supriman cuando sean inexactos.\r\n\r\n**4.4. Más información**\r\n\r\nConsulte nuestra [Política de Privacidad](/pt/politica-de-privacidad) para más información sobre el tratamiento de sus datos personales. \r\n\r\n\r\n"},{"title":"5.- ACTUALIZACIONES Y CAMBIOS EN LA POLÍTICA DE COOKIES","text":"Le informamos de que nuestra Política de Cookies se podrá modificar en cualquier momento (sobre todo teniendo en cuenta nuevas exigencias legislativas, reglamentarias o con el objetivo de adaptar dicha política a las instrucciones dictadas por la Agencia Española de Protección de Datos). Cuando se produzcan cambios significativos en esta Política de Cookies se comunicará al usuario mediante un aviso informativo en la página web."}]}}]},"allBicenturyNavbar":{"edges":[{"node":{"id":"Bicentury__Navbar__navbar-es","title":"Navbar","lang":"es","navbarItems":{"top_left":[{"text":"-","link":" ","linktype":"internal"}],"top":[{"text":"Hacerlo bien","link":"hacerlo-bien","linktype":"internal"},{"text":"Contacto","link":"contacto","linktype":"internal"}],"bottom":[{"text":"Hacerlo bien","link":"hacerlo-bien","linktype":"internal"},{"text":"Nota legal","link":"nota-legal","linktype":"internal"},{"text":"Política de privacidad","link":"politica-de-privacidad","linktype":"internal"},{"text":"Política de cookies","link":"cookies","linktype":"cookie"}]},"footerPages":[{"id":"asi-somos","title":"Así Somos","type":"company","lang":"es","path":"/asi-somos","userDefinedId":"asi-somos"},{"id":"colaboramos","title":"Colaboramos con AEDN","type":"privacity","lang":"es","path":"/colaboramos","userDefinedId":"colaboramos"},{"id":"contacto","title":"Contacto","type":"contact","lang":"es","path":"/contacto","userDefinedId":"contacto"},{"id":"cookies","title":"Política de cookies","type":"cookies","lang":"es","path":"/cookies","userDefinedId":"cookies"},{"id":"nota-legal","title":"Nota legal","type":"legal","lang":"es","path":"/nota-legal","userDefinedId":"nota-legal"},{"id":"politica-de-privacidad","title":"Política de privacidad","type":"politics","lang":"es","path":"/politica-de-privacidad","userDefinedId":"politica-de-privacidad"}],"products":[{"id":"mundo-tortitas","title":"Tortitas","lang":"es","path":"/worlds/mundo-tortitas"},{"id":"mundo-snacks-choco","title":"Snacks choco","lang":"es","path":"/worlds/mundo-snacks-choco"},{"id":"mundo-proteina","title":"La proteína de tu día","lang":"es","path":"/worlds/mundo-proteina"},{"id":"galletas","title":"Galletas","lang":"es","path":"/products/galletas"},{"id":"cero-azucares","title":"0% azúcares añadidos","lang":"es","path":"/products/cero-azucares"}]}},{"node":{"id":"Bicentury__Navbar__navbar-pt","title":"Navbar","lang":"pt","navbarItems":{"top_left":null,"top":[{"text":"Faze-lo bem","link":"hacerlo-bien","linktype":"internal"},{"text":"Contacto","link":"contacto","linktype":"internal"}],"bottom":[{"text":"Faze-lo bem","link":"hacerlo-bien","linktype":"internal"},{"text":"Aviso legal","link":"nota-legal","linktype":"internal"},{"text":"Política de privacidade","link":"politica-de-privacidad","linktype":"internal"},{"text":"Política de cookies","link":"cookies","linktype":"cookie"}]},"footerPages":[{"id":"asi-somos","title":"Somos assim","type":"company","lang":"pt","path":"/asi-somos","userDefinedId":"asi-somos"},{"id":"colaboramos","title":"Colaboramos con AEDN","type":"privacity","lang":"pt","path":"/colaboramos","userDefinedId":"colaboramos"},{"id":"contacto","title":"Contacto","type":"contact","lang":"pt","path":"/contacto","userDefinedId":"contacto"},{"id":"cookies","title":"Política de cookies","type":"cookies","lang":"pt","path":"/cookies","userDefinedId":"cookies"},{"id":"nota-legal","title":"Aviso legal","type":"legal","lang":"pt","path":"/nota-legal","userDefinedId":"nota-legal"},{"id":"politica-de-privacidad","title":"Política de privacidade","type":"politics","lang":"pt","path":"/politica-de-privacidad","userDefinedId":"politica-de-privacidad"}],"products":[{"id":"mundo-tortitas","title":"Bolachas","lang":"pt","path":"/worlds/mundo-tortitas"},{"id":"mundo-snacks-choco","title":"Snacks choco","lang":"pt","path":"/worlds/mundo-snacks-choco"},{"id":"mundo-proteina","title":"A proteína do seu dia","lang":"pt","path":"/worlds/mundo-proteina"},{"id":"galletas","title":"Galletas","lang":"pt","path":"/products/galletas"},{"id":"cero-azucares","title":"0% açúcares adicionados","lang":"pt","path":"/products/cero-azucares"}]}}]}},"layoutContext":{}}

/***/ }),

/***/ 398:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(419);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(174);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 254:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 128:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _markdownReactJs = __webpack_require__(18);
	
	var _markdownReactJs2 = _interopRequireDefault(_markdownReactJs);
	
	var _gatsbyLink = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isClient = typeof window !== 'undefined';
	
	function getCookie(name) {
	    if (isClient) {
	        var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
	        return v ? v[2] : null;
	    } else return null;
	}
	
	var CookiesBox = function (_Component) {
	    _inherits(CookiesBox, _Component);
	
	    function CookiesBox(props) {
	        _classCallCheck(this, CookiesBox);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	        _this.acceptCookies = function () {
	            if (isClient) {
	                var d = new Date();
	                d.setTime(d.getTime() + 730 * 24 * 60 * 60 * 1000); //2 años meses son 730 dias
	                var expires = "expires=" + d.toUTCString();
	
	                console.log('expira en : ', expires);
	                document.cookie = "gatsby-plugin-google-analytics-gdpr_cookies-enabled=true" + ";" + expires + ";path=/";
	                document.cookie = "cookies-accepted=true" + ";" + expires + ";path=/";
	                _this.setState({ viewCookies: false });
	                window.localStorage.setItem('cookiesMessageBicentury', true);
	                //window.location.reload();
	            }
	        };
	
	        _this.rejectCookies = function () {
	            console.log("REJECTING");
	            if (isClient) {
	                var d = new Date();
	                d.setTime(d.getTime() + 730 * 24 * 60 * 60 * 1000); //2 años meses son 730 dias
	                var expires = "expires=" + d.toUTCString();
	                document.cookie = "gatsby-plugin-google-analytics-gdpr_cookies-enabled=false" + ";" + expires + ";path=/";
	                document.cookie = "cookies-accepted=false" + ";" + expires + ";path=/";
	                _this.setState({ viewCookies: false });
	                window.localStorage.setItem('cookiesMessageBicentury', true);
	                //window.location.reload();
	            }
	        };
	
	        _this.lang = props.lang;
	        _this.state = {
	            viewCookies: props.stateComp
	        };
	        _this.translations = props.translations;
	        _this.activeCookiesLayer = props.onClickActiveCookiesControl;
	        _this.linkRenderer = _this.linkRenderer.bind(_this);
	        return _this;
	    }
	
	    CookiesBox.prototype.linkRenderer = function linkRenderer(Tag, props, children, level) {
	        if (Tag === 'a' && (props.href === '#cookieLayerLink' || props.href === '#cookieControlLink')) {
	            props = _extends({}, props, {
	                onClick: this.activeCookiesLayer
	            });
	        } else if (Tag == 'a') {
	            props = _extends({}, props, {
	                target: '_blank'
	            });
	        }
	        return _react2.default.createElement(
	            Tag,
	            props,
	            children
	        );
	    };
	
	    CookiesBox.prototype.componentDidMount = function componentDidMount() {
	        if (isClient) {
	            var cookiesAccepted = isClient ? getCookie('cookies-accepted') != null : false;
	            this.setState({ viewCookies: !cookiesAccepted });
	        }
	    };
	
	    CookiesBox.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	
	        var existCookieBoxStorage = localStorage.getItem('cookiesMessageBicentury');
	
	        if (nextProps.stateComp === false && existCookieBoxStorage === 'true') {
	            this.setState({ viewCookies: nextProps.stateComp });
	            var d = new Date();
	            d.setTime(d.getTime() + 182 * 24 * 60 * 60 * 1000); //6 meses  182 dias
	            var expires = "expires=" + d.toUTCString();
	            window.localStorage.setItem('cookiesMessageBicentury', true);
	            //document.cookie="cookies-accepted=false;"+expires+";path=/";
	        }
	    };
	
	    CookiesBox.prototype.render = function render() {
	
	        var cookiesClass = 'cookiesBox ' + (this.state.viewCookies == true ? '' : 'hideMessage');
	
	        return _react2.default.createElement(
	            'div',
	            { className: cookiesClass },
	            _react2.default.createElement(
	                'div',
	                { className: 'cookiesBox-wrapper' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'cookiesBox-animation' },
	                    _react2.default.createElement('img', { src: (0, _gatsbyLink.withPrefix)('/images/tortita.gif') })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'cookiesBox-message' },
	                    _react2.default.createElement(
	                        'h4',
	                        null,
	                        this.translations.cookielayer_title
	                    ),
	                    _react2.default.createElement(_markdownReactJs2.default, { text: this.translations.cookielayer_text, onIterate: this.linkRenderer }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'cookiesBox-buttons' },
	                        _react2.default.createElement(
	                            'button',
	                            { className: 'btn notdef', onClick: this.rejectCookies },
	                            this.translations.cookielayer_reject
	                        ),
	                        _react2.default.createElement(
	                            'button',
	                            { className: 'btn notdef' },
	                            _react2.default.createElement(
	                                'a',
	                                { href: '#cookieControlLink', onClick: this.activeCookiesLayer },
	                                this.translations.cookielayer_configure
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'button',
	                            { className: 'btn', onClick: this.acceptCookies },
	                            this.translations.cookielayer_acceptall
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return CookiesBox;
	}(_react.Component);
	
	;
	
	exports.default = CookiesBox;
	module.exports = exports['default'];

/***/ }),

/***/ 129:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _markdownReactJs = __webpack_require__(18);
	
	var _markdownReactJs2 = _interopRequireDefault(_markdownReactJs);
	
	var _gatsbyLink = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isClient = typeof window !== 'undefined';
	
	function linkRenderer(Tag, props, children, level) {
	  if (Tag === 'a') {
	    props = _extends({}, props, {
	      target: '_blank'
	    });
	  }
	  return _react2.default.createElement(
	    Tag,
	    props,
	    children
	  );
	}
	
	function getCookie(name) {
	  if (isClient) {
	    var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
	    return v ? v[2] : null;
	  } else return null;
	}
	
	var CookiesControl = function (_Component) {
	  _inherits(CookiesControl, _Component);
	
	  function CookiesControl(props) {
	    _classCallCheck(this, CookiesControl);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.lang = props.lang;
	    _this.state = {
	      viewCookies: false,
	      cookiesAccepted: isClient ? getCookie('cookies-accepted') === "true" : false
	    };
	    _this.translations = props.translations;
	
	    _this.closeCookiesLayer = props.closeLayer;
	    _this.closeCookiesBox = props.closeCookiesBox;
	
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.closeLayer = _this.closeLayer.bind(_this);
	    _this.handleBtnAccept = _this.handleBtnAccept.bind(_this);
	    _this.cookiesAccepted = isClient ? getCookie('cookies-accepted') === "true" : false;
	    return _this;
	  }
	
	  CookiesControl.prototype.handleChange = function handleChange(event) {
	
	    var checkValue = event.target.checked;
	    console.log("accepted:" + this.cookiesAccepted + "-" + checkValue);
	    this.state.cookiesAccepted = checkValue;
	
	    if (checkValue) {
	      if (isClient) {
	        var d = new Date();
	        d.setTime(d.getTime() + 365 * 2 * 24 * 60 * 60 * 1000);
	        var expires = "expires=" + d.toUTCString();
	        document.cookie = "gatsby-plugin-google-analytics-gdpr_cookies-enabled=true" + ";" + expires + ";path=/";
	        document.cookie = "cookies-accepted=true" + ";" + expires + ";path=/";
	      }
	    } else {
	      if (isClient) {
	        var d = new Date();
	        d.setTime(d.getTime() + 180 * 24 * 60 * 60 * 1000);
	        var expires = "expires=" + d.toUTCString();
	        console.log("setting accept cookies to false");
	        document.cookie = "gatsby-plugin-google-analytics-gdpr_cookies-enabled=false" + ";" + expires + ";path=/";
	        document.cookie = "cookies-accepted=false" + ";" + expires + ";path=/";
	        console.log("Removing ga cookies");
	        document.cookie = "_ga=NOTHING; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=." + window.location.hostname;
	        document.cookie = "_gat=NOTHING; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=." + window.location.hostname;
	        document.cookie = "_gid=NOTHING; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=." + window.location.hostname;
	      }
	    }
	    this.setState(this.state);
	  };
	
	  CookiesControl.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.openLayer !== this.state.viewCookies) {
	      this.setState({ viewCookies: nextProps.openLayer });
	    }
	  };
	
	  CookiesControl.prototype.closeLayer = function closeLayer() {
	    this.setState({ viewCookies: false });
	    if (this.state.cookiesAccepted == false) {
	      if (isClient) {
	        //if there is no cookie to false,put it to false
	        if (getCookie("cookies-accepted") == null) {
	          var d = new Date();
	          d.setTime(d.getTime() + 180 * 24 * 60 * 60 * 1000);
	          var expires = "expires=" + d.toUTCString();
	          console.log("setting accept cookies to false");
	          document.cookie = "gatsby-plugin-google-analytics-gdpr_cookies-enabled=false" + ";" + expires + ";path=/";
	          document.cookie = "cookies-accepted=false" + ";" + expires + ";path=/";
	          console.log("Removing ga cookies");
	          document.cookie = "_ga=NOTHING; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=." + window.location.hostname;
	          document.cookie = "_gat=NOTHING; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=." + window.location.hostname;
	          document.cookie = "_gid=NOTHING; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=." + window.location.hostname;
	        }
	      }
	    }
	    this.closeCookiesLayer();
	  };
	
	  CookiesControl.prototype.handleBtnAccept = function handleBtnAccept() {
	    this.setState({ viewCookies: false });
	    this.closeCookiesBox();
	  };
	
	  CookiesControl.prototype.render = function render() {
	
	    var printParagraf = function printParagraf(item, idx) {
	      return _react2.default.createElement(
	        'div',
	        { key: idx },
	        _react2.default.createElement(
	          'h4',
	          null,
	          item.title
	        ),
	        _react2.default.createElement(_markdownReactJs2.default, { text: item.text, onIterate: linkRenderer })
	      );
	    };
	
	    var showLayerClass = this.state.viewCookies == true ? 'cookiesControl showLayer' : 'cookiesControl';
	
	    return _react2.default.createElement(
	      'div',
	      { className: showLayerClass },
	      _react2.default.createElement(
	        'div',
	        { className: 'cookiesControl-wrapper' },
	        _react2.default.createElement('div', {
	          className: 'closeBox',
	          onClick: this.closeLayer }),
	        _react2.default.createElement(
	          'h2',
	          null,
	          this.translations.cookiecp_title
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'cookiesControl-content' },
	          _react2.default.createElement(_markdownReactJs2.default, { text: this.translations.cookiecp_text, onIterate: linkRenderer }),
	          this.translations.cookiecp_firsts_paragraphs.map(printParagraf),
	          _react2.default.createElement(
	            'h3',
	            { id: 'cookieControlLink' },
	            this.translations.cookiecp_own_title
	          ),
	          _react2.default.createElement(_markdownReactJs2.default, { text: this.translations.cookiecp_own_text, onIterate: linkRenderer }),
	          _react2.default.createElement(
	            'div',
	            { className: 'cookiesControl-ckcntrl' },
	            _react2.default.createElement(
	              'label',
	              { className: 'toggle-switch' },
	              _react2.default.createElement('input', { id: 'checkbox-disabled', type: 'checkbox', checked: true, disabled: true }),
	              _react2.default.createElement(
	                'span',
	                { className: 'toggle-switch-slider toggle-switch-slider__disabled' },
	                ' '
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'titleCookie' },
	              this.translations.cookiecp_tech_title
	            ),
	            _react2.default.createElement(_markdownReactJs2.default, { text: this.translations.cookiecp_tech_text, onIterate: linkRenderer, className: 'desc' })
	          ),
	          _react2.default.createElement(
	            'h3',
	            null,
	            this.translations.cookiecp_third_title
	          ),
	          _react2.default.createElement(_markdownReactJs2.default, { text: this.translations.cookiecp_third_text, onIterate: linkRenderer }),
	          _react2.default.createElement(
	            'div',
	            { className: 'cookiesControl-ckcntrl' },
	            _react2.default.createElement(
	              'label',
	              { className: 'toggle-switch' },
	              _react2.default.createElement('input', { id: 'checkbox', type: 'checkbox', checked: this.state.cookiesAccepted, onChange: this.handleChange }),
	              _react2.default.createElement(
	                'span',
	                { className: 'toggle-switch-slider' },
	                ' '
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'titleCookie' },
	              this.translations.cookiecp_analytics_title
	            ),
	            _react2.default.createElement(_markdownReactJs2.default, { text: this.translations.cookiecp_analytics_text, onIterate: linkRenderer, className: 'desc-sec' }),
	            _react2.default.createElement(
	              'p',
	              { className: 'desc-text' },
	              this.translations.cookiecp_analytics_name
	            )
	          ),
	          this.translations.cookiecp_last_paragraphs.map(printParagraf)
	        )
	      )
	    );
	  };
	
	  return CookiesControl;
	}(_react.Component);
	
	;
	
	exports.default = CookiesControl;
	module.exports = exports['default'];

/***/ }),

/***/ 130:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(4);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactRouterDom = __webpack_require__(65);
	
	var _logoFooter = __webpack_require__(293);
	
	var _logoFooter2 = _interopRequireDefault(_logoFooter);
	
	var _iconFooterFacebook = __webpack_require__(287);
	
	var _iconFooterFacebook2 = _interopRequireDefault(_iconFooterFacebook);
	
	var _iconFooterInstagram = __webpack_require__(288);
	
	var _iconFooterInstagram2 = _interopRequireDefault(_iconFooterInstagram);
	
	var _iconFooterYoutube = __webpack_require__(289);
	
	var _iconFooterYoutube2 = _interopRequireDefault(_iconFooterYoutube);
	
	var _markdownReactJs = __webpack_require__(18);
	
	var _markdownReactJs2 = _interopRequireDefault(_markdownReactJs);
	
	var _gatsbyPluginGoogleAnalytics = __webpack_require__(25);
	
	var _link = __webpack_require__(41);
	
	var _link2 = _interopRequireDefault(_link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Footer = function (_Component) {
		_inherits(Footer, _Component);
	
		function Footer(props) {
			_classCallCheck(this, Footer);
	
			var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
			_this.lang = props.lang;
			_this.data = props.data;
			_this.translations = props.translations;
			_this.activeCookiesLayer = props.onClickActiveCookiesControl;
	
			//console.log('data info', this.data);
	
			_this.contact = _this.data.footerPages.map(function (x) {
				return x;
			}).filter(function (x) {
				return x.type === 'contact';
			})[0];
			_this.company = _this.data.footerPages.map(function (x) {
				return x;
			}).filter(function (x) {
				return x.type === 'company';
			})[0];
			_this.legal = _this.data.footerPages.map(function (x) {
				return x;
			}).filter(function (x) {
				return x.type === 'legal';
			})[0];
			_this.privacity = _this.data.footerPages.map(function (x) {
				return x;
			}).filter(function (x) {
				return x.type === 'privacity';
			})[0];
			_this.politica = _this.data.footerPages.map(function (x) {
				return x;
			}).filter(function (x) {
				return x.type === 'politics';
			})[0];
			return _this;
		}
	
		Footer.prototype.render = function render() {
			var _this2 = this;
	
			var productList = function productList(child, idx) {
				return _react2.default.createElement(
					'li',
					{ key: idx },
					_react2.default.createElement(
						_gatsbyLink2.default,
						{ to: '/' + child.lang + child.path, title: '' },
						child.title
					)
				);
			};
			var location = '';
			if ("undefined" != typeof window) {
				location = window.location.pathname;
			}
			var splittedValue = location.split('/');
			var path_1 = '/',
			    path_2 = '';
			for (var i = 2; i < splittedValue.length; i++) {
				path_2 += splittedValue[i];
				if (i < splittedValue.length - 1) {
					path_2 += '/';
				}
			}
			if (path_2 === '/') {
				path_2 = '';
			}
			if (path_2.length > 0) {
				path_2 = '/' + path_2;
			}
	
			var footerItems = function footerItems(item, idx) {
				if (item.linktype == 'cookie') {
					return _react2.default.createElement(
						'li',
						{ key: idx, className: 'fakeLink' },
						_react2.default.createElement(
							'span',
							{ onClick: _this2.activeCookiesLayer },
							item.text
						)
					);
				} else {
					return _react2.default.createElement(
						'li',
						{ key: idx },
						_react2.default.createElement(_link2.default, { link: '/' + item.link, lang: _this2.lang, text: item.text, type: item.linktype })
					);
				}
			};
	
			return _react2.default.createElement(
				'footer',
				null,
				_react2.default.createElement(
					'section',
					{ className: 'pre-footer' },
					_react2.default.createElement(
						'div',
						{ className: 'container' },
						_react2.default.createElement(
							'div',
							{ className: 'row' },
							_react2.default.createElement(
								'div',
								{ className: 'small-12' },
								_react2.default.createElement(
									'h2',
									{ className: 'white unicSize' },
									this.translations.attitude_title
								),
								_react2.default.createElement(
									'div',
									{ className: 'content-text' },
									_react2.default.createElement(_markdownReactJs2.default, { text: this.translations.attitude_text })
								),
								_react2.default.createElement(
									'ul',
									{ className: 'tags' },
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											'p',
											null,
											this.translations.attitude_hashtags
										)
									)
								)
							)
						)
					)
				),
				_react2.default.createElement(
					'section',
					{ className: 'post-footer' },
					_react2.default.createElement(
						'div',
						{ className: 'container' },
						_react2.default.createElement(
							'div',
							{ className: 'row logo-container' },
							_react2.default.createElement(
								'div',
								{ className: 'small-12' },
								_react2.default.createElement('img', { src: _logoFooter2.default, alt: '' })
							)
						),
						_react2.default.createElement(
							'ul',
							{ className: 'row principal-list' },
							_react2.default.createElement(
								'li',
								{ className: 'small-4 medium-3' },
								_react2.default.createElement(
									'p',
									null,
									this.translations.menu
								),
								_react2.default.createElement(
									'ul',
									null,
									this.data.products.map(productList)
								)
							),
							_react2.default.createElement(
								'li',
								{ className: 'small-4 medium-3' },
								_react2.default.createElement(
									'p',
									null,
									this.translations.languages
								),
								_react2.default.createElement(
									'ul',
									{ 'data-is-languages-list': true },
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											'a',
											{ href: path_1 + 'es' + path_2, title: 'Castellano', 'data-lang': 'es' },
											'Castellano'
										)
									),
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											'a',
											{ href: path_1 + 'pt' + path_2, title: 'Portugu\xEAs', 'data-lang': 'pt' },
											'Portugu\xEAs'
										)
									)
								)
							),
							_react2.default.createElement(
								'li',
								{ className: 'small-4 medium-3' },
								_react2.default.createElement(
									'p',
									null,
									'Bicentury'
								),
								_react2.default.createElement(
									'ul',
									null,
									this.data.navbarItems.bottom.map(footerItems)
								)
							),
							_react2.default.createElement(
								'li',
								{ className: 'small-12 medium-3' },
								_react2.default.createElement(
									'p',
									null,
									this.translations.followus
								),
								_react2.default.createElement(
									'ul',
									{ className: 'social' },
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											_gatsbyPluginGoogleAnalytics.OutboundLink,
											{ href: 'https://www.facebook.com/Bicentury/', title: 'Facebook', target: '_blank' },
											_react2.default.createElement('img', { src: _iconFooterFacebook2.default, alt: 'Facebook' })
										)
									),
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											_gatsbyPluginGoogleAnalytics.OutboundLink,
											{ href: 'https://www.instagram.com/bicentury/', title: 'Instagram', target: '_blank' },
											_react2.default.createElement('img', { src: _iconFooterInstagram2.default, alt: 'Instagram' })
										)
									),
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											_gatsbyPluginGoogleAnalytics.OutboundLink,
											{ href: 'https://www.youtube.com/user/BicenturyMKT', title: 'YouTube', target: '_blank' },
											_react2.default.createElement('img', { src: _iconFooterYoutube2.default, alt: 'YouTube' })
										)
									)
								)
							)
						)
					)
				)
			);
		};
	
		return Footer;
	}(_react.Component);
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 131:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _cookiesBox = __webpack_require__(128);
	
	var _cookiesBox2 = _interopRequireDefault(_cookiesBox);
	
	var _cookiesControl = __webpack_require__(129);
	
	var _cookiesControl2 = _interopRequireDefault(_cookiesControl);
	
	var _footer = __webpack_require__(130);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FooterComponents = function (_Component) {
	  _inherits(FooterComponents, _Component);
	
	  function FooterComponents(props) {
	    _classCallCheck(this, FooterComponents);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.lang = props.lang;
	    _this.translations = props.translations;
	    _this.data = props.dataProducts;
	
	    _this.state = {
	      openLayer: false,
	      cookiesMessageState: false
	    };
	
	    _this.onClickActiveCookiesControl = _this.onClickActiveCookiesControl.bind(_this);
	    _this.onClickCloseCookiesControl = _this.onClickCloseCookiesControl.bind(_this);
	    _this.onClickCloseCookiesControl = _this.onClickCloseCookiesControl.bind(_this);
	    return _this;
	  }
	
	  FooterComponents.prototype.onClickActiveCookiesControl = function onClickActiveCookiesControl() {
	    this.setState({ openLayer: true });
	  };
	
	  FooterComponents.prototype.onClickCloseCookiesControl = function onClickCloseCookiesControl() {
	    this.setState({ openLayer: false });
	    window.localStorage.setItem('cookiesMessageBicentury', true);
	  };
	
	  FooterComponents.prototype.onClickCloseCookiesBox = function onClickCloseCookiesBox() {
	    this.setState({ cookiesMessageState: false });
	  };
	
	  FooterComponents.prototype.render = function render() {
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_footer2.default, {
	        lang: this.lang,
	        data: this.data,
	        translations: this.translations,
	        onClickActiveCookiesControl: this.onClickActiveCookiesControl
	      }),
	      _react2.default.createElement(_cookiesBox2.default, {
	        lang: this.lang,
	        translations: this.translations,
	        onClickActiveCookiesControl: this.onClickActiveCookiesControl,
	        stateComp: this.state.cookiesMessageState
	      }),
	      _react2.default.createElement(_cookiesControl2.default, {
	        lang: this.lang,
	        translations: this.translations,
	        openLayer: this.state.openLayer,
	        closeLayer: this.onClickCloseCookiesControl,
	        closeCookiesBox: this.onClickCloseCookiesBox
	      })
	    );
	  };
	
	  return FooterComponents;
	}(_react.Component);
	
	;
	
	exports.default = FooterComponents;
	module.exports = exports['default'];

/***/ }),

/***/ 132:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Go to top button
	 */
	var GoToTop = function (_Component) {
		_inherits(GoToTop, _Component);
	
		function GoToTop(props) {
			_classCallCheck(this, GoToTop);
	
			var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
			_this.handleGoToTop = function (scrollDuration) {
				var cosParameter = window.scrollY / 2,
				    scrollCount = 0,
				    oldTimestamp = performance.now();
				function step(newTimestamp) {
					scrollCount += Math.PI / (scrollDuration / (newTimestamp - oldTimestamp));
					if (scrollCount >= Math.PI) window.scrollTo(0, 0);
					if (window.scrollY === 0) return;
					window.scrollTo(0, Math.round(cosParameter + cosParameter * Math.cos(scrollCount)));
					oldTimestamp = newTimestamp;
					window.requestAnimationFrame(step);
				}
				window.requestAnimationFrame(step);
			};
	
			_this.state = { scrollToTopButton: false };
			return _this;
		}
	
		GoToTop.prototype.componentDidMount = function componentDidMount() {
			var _this2 = this;
	
			window.addEventListener('scroll', function () {
				if (window.scrollY > 100) {
					_this2.setState({ scrollToTopButton: true });
				} else {
					_this2.setState({ scrollToTopButton: false });
				}
			});
		};
	
		GoToTop.prototype.render = function render() {
			var _this3 = this;
	
			var goToTopClass = 'goToTop ' + (this.state.scrollToTopButton ? 'visible' : '');
			return _react2.default.createElement(
				'section',
				{ className: goToTopClass, onClick: function onClick() {
						return _this3.handleGoToTop(300);
					} },
				_react2.default.createElement('div', null)
			);
		};
	
		return GoToTop;
	}(_react.Component);
	
	exports.default = GoToTop;
	module.exports = exports['default'];

/***/ }),

/***/ 133:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(4);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyPluginGoogleAnalytics = __webpack_require__(25);
	
	var _iconHeaderFacebook = __webpack_require__(290);
	
	var _iconHeaderFacebook2 = _interopRequireDefault(_iconHeaderFacebook);
	
	var _iconHeaderInstagram = __webpack_require__(291);
	
	var _iconHeaderInstagram2 = _interopRequireDefault(_iconHeaderInstagram);
	
	var _iconHeaderYoutube = __webpack_require__(292);
	
	var _iconHeaderYoutube2 = _interopRequireDefault(_iconHeaderYoutube);
	
	var _logo = __webpack_require__(294);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _iconArrowDown = __webpack_require__(286);
	
	var _iconArrowDown2 = _interopRequireDefault(_iconArrowDown);
	
	var _link = __webpack_require__(41);
	
	var _link2 = _interopRequireDefault(_link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Header = function (_Component) {
		_inherits(Header, _Component);
	
		function Header(props) {
			_classCallCheck(this, Header);
	
			var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
			_this.toggleMenu = function () {
				_this.setState(function (prevState) {
					return {
						menuState: !prevState.menuState
					};
				});
			};
	
			_this.closeMenu = function () {
				_this.setState(function (prevState) {
					return {
						menuState: false
					};
				});
			};
	
			_this.state = { menuState: false, subMenu: false };
			_this.data = props.data;
			_this.lang = props.lang;
			_this.translations = props.translations;
			if ("undefined" === typeof _this.data.navbarItems.top_left || !_this.data.navbarItems.top_left) {
				_this.data.navbarItems.top_left = [];
			}
			return _this;
		}
	
		// toggleSubMenu = () => {
		// 	this.setState((prevState) => ({
		// 		subMenu: !prevState.subMenu
		// 	}))
		// };
	
		Header.prototype.render = function render() {
			var _this2 = this;
	
			var headerStatus = 'header ' + (this.state.menuState ? 'active' : '');
			var headerSubMenuStatus = 'sub-items ' + (this.state.subMenu ? 'active' : 'active');
	
			var listProducts = function listProducts(child, idx) {
				return _react2.default.createElement(
					'li',
					{ key: idx },
					_react2.default.createElement(
						_gatsbyLink2.default,
						{ to: '/' + child.lang + child.path, title: '', onClick: _this2.closeMenu },
						child.title
					)
				);
			};
	
			var navbarItem = function navbarItem(item, idx) {
				if (item.text.trim() == '' || item.text.trim() == '-') {
					return _react2.default.createElement('li', { key: idx });
				} else {
					return _react2.default.createElement(
						'li',
						{ key: idx },
						_react2.default.createElement(
							'p',
							null,
							_react2.default.createElement(_link2.default, {
								link: '/' + item.link,
								text: '' + item.text,
								type: item.linktype,
								lang: _this2.lang,
								onClick: _this2.closeMenu })
						)
					);
				}
			};
	
			return _react2.default.createElement(
				'header',
				{ className: headerStatus },
				_react2.default.createElement(
					'div',
					{ className: 'container-fluid' },
					_react2.default.createElement(
						'div',
						{ className: 'row' },
						_react2.default.createElement(
							'div',
							{ className: 'small-12 medium-12 large-3' },
							_react2.default.createElement(
								'div',
								{ className: 'logo-container' },
								_react2.default.createElement(
									_gatsbyLink2.default,
									{ to: '/' + this.lang, title: 'Home', onClick: this.closeMenu },
									_react2.default.createElement('img', { src: _logo2.default })
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'small-12 medium-12 large-9' },
							_react2.default.createElement(
								'div',
								{ className: 'menu-container' },
								_react2.default.createElement(
									'ul',
									{ className: 'menu' },
									this.data.navbarItems.top_left.map(navbarItem),
									_react2.default.createElement(
										'li',
										{ className: headerSubMenuStatus, style: { backgroundImage: 'url(' + _iconArrowDown2.default + ')' } },
										_react2.default.createElement(
											'p',
											null,
											this.translations.products
										),
										_react2.default.createElement(
											'ul',
											null,
											this.data.products.map(listProducts)
										)
									),
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											'p',
											null,
											_react2.default.createElement(
												_gatsbyLink2.default,
												{
													to: '/' + this.lang + '/gustazos',
													title: 'Gustazos',
													onClick: this.closeMenu
												},
												this.translations.gustazos
											)
										)
									),
									this.data.navbarItems.top.map(navbarItem),
									_react2.default.createElement(
										'li',
										null,
										_react2.default.createElement(
											'ul',
											{ className: 'social' },
											_react2.default.createElement(
												'li',
												null,
												_react2.default.createElement(
													_gatsbyPluginGoogleAnalytics.OutboundLink,
													{ href: 'https://www.facebook.com/Bicentury/', title: 'Facebook', target: '_blank' },
													_react2.default.createElement('img', { src: _iconHeaderFacebook2.default, alt: 'Facebook' })
												)
											),
											_react2.default.createElement(
												'li',
												null,
												_react2.default.createElement(
													_gatsbyPluginGoogleAnalytics.OutboundLink,
													{ href: 'https://www.instagram.com/bicentury/', title: 'Instagram', target: '_blank' },
													_react2.default.createElement('img', { src: _iconHeaderInstagram2.default, alt: 'Instagram' })
												)
											),
											_react2.default.createElement(
												'li',
												null,
												_react2.default.createElement(
													_gatsbyPluginGoogleAnalytics.OutboundLink,
													{ href: 'https://www.youtube.com/user/BicenturyMKT', title: 'YouTube', target: '_blank' },
													_react2.default.createElement('img', { src: _iconHeaderYoutube2.default, alt: 'YouTube' })
												)
											)
										)
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'menu-icon', onClick: this.toggleMenu },
								_react2.default.createElement('div', null),
								_react2.default.createElement('div', null),
								_react2.default.createElement('div', null)
							)
						)
					)
				)
			);
		};
	
		return Header;
	}(_react.Component);
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(4);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyPluginGoogleAnalytics = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//<Link className="btn" to={link} title={text}>{text}</Link>
	//<OutboundLink className="btn" href={link} title={text}>{text}</OutboundLink>
	var BicenturyLink = function BicenturyLink(_ref) {
		var text = _ref.text,
		    link = _ref.link,
		    type = _ref.type,
		    className = _ref.className,
		    lang = _ref.lang,
		    onClick = _ref.onClick;
	
		var inner_link = link;
		if ("undefined" === typeof type || type === 'internal') {
			if ("undefined" != typeof lang && lang) {
				inner_link = '/' + lang + link;
			}
			return _react2.default.createElement(
				_gatsbyLink2.default,
				{ className: className, to: inner_link, title: text, onClick: onClick },
				text
			);
		} else if (type === 'external') {
			return _react2.default.createElement(
				_gatsbyPluginGoogleAnalytics.OutboundLink,
				{ className: className, href: link, target: '_blank' },
				text
			);
		} else if (type === 'cookie') {
			return _react2.default.createElement(
				_gatsbyLink2.default,
				{ className: className, to: inner_link, title: text, onClick: onClick },
				text
			);
		} else {
			return _react2.default.createElement(
				_gatsbyPluginGoogleAnalytics.OutboundLink,
				{ className: className, href: link },
				text
			);
		}
	};
	
	exports.default = BicenturyLink;
	module.exports = exports['default'];

/***/ }),

/***/ 286:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAANCAMAAABrcDXcAAAAV1BMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////+ORg7oAAAAHHRSTlMA+w3b9+Q2KhbLxfHu69KxlYJ7cmZgVk9GQSIcep2C4QAAAINJREFUGNNlj9kOgzAMwNIySrnv2///nWs0hFjxkyUrSiKdaa3E2NZ0YiD3UfA5GOmB5PwLZwL0IgOQZo+QpcCgNhmo3R1cDWb6+RJSuV9hL0NY5GL7wGcVZVXd5MZVYOYgs4HKSbx1lDG6Rjn00kI/OCTCNyiNlxe20Ckb7J1ykkf4AkluCSlZuR3HAAAAAElFTkSuQmCC"

/***/ }),

/***/ 287:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAhCAMAAABgOjJdAAAAdVBMVEUAAAD////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////li2ZAAAAAJ3RSTlMA/tkNCPhBRN02JOGuv35sTbFPA7aZOony8JuajHpRSD8Ct3YPzRNmOuw5AAABKUlEQVQ4y4VU2XKDMAyUZCDGBnOEI/fVtP//iZ3SEtYuhH2TZ2elRVoIkLpG73mvG5fSDKJC5FSbJz1NfRIpopBQ26qDsqts7Qu0kpCPRFqQUXmmKITKcvVSyA80g+0hH1XaakuzlKz9G1IUzUNJPfSwCS0hsT99igrfbp/MH1NZFUQkHba2zDEwOiFKxZNlPl8NPEhK7oSMDfPmjg+9o6acyq/rOdQoG9JQJ3HMHMcbYBhNewU9fhnoXu2IobxHJXMZeYPwqDF5GRRQQ5vQi8cwGrwgA724/i2jd+M3ndz4DEmDvSS+V+pk2i0i2O36fdBl7caIjtnSnR5ft35cuvX1vGDmbgHhhpkbxrUZBj7N7OV/9rX0pVGkTNmLxuzj/+Ohd7zTD4dy31UdDWP8zBT5AAAAAElFTkSuQmCC"

/***/ }),

/***/ 288:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAhCAMAAABgOjJdAAAAh1BMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////9qkf8RAAAALHRSTlMA2Q4HmcOw3U5BNgyKf/Bs8uysJOCbUDoDt7RczL770pfhvaF2cGVJLhynJm26eyYAAAFPSURBVDjLjZPXcsIwEEWvBCru3eBC74n+//syjlFWgGFynmz5zMq62oWDH7UqNrFqIx8TzBLGQv3NwQsdMpbMngW9kwsQC1nqxwJz5uERj82dMnyVczzD89Xf4mxfYYJltbdVtnKJSUVux4eacUwTsPp3j9LDO7xy2CeR41sXGyLuxkWZAGD3HDL6fJAmvefCAJ9hhApEQG8wwnxE4YsRAhtrhBFa/WKsxcZYQzdQxYPx1R3MgDUKhZhbI76cTQ9AmKOXWYOnMLCGwM00AHLjQdCyU0MAm/Xpel5nARlBClU4xnUIJb0AwvmPVjsG+Gl7vMExdOPk0YPoKQ/KNDPt3DKkbjOle+kyQ2SdvRe622lk8q/+QM2Czz0GVPmbPs0r2+viTa+L2cd5CWhePs4cUZfSB+HLXf1SNFEs1EWAYJh9lUyez48alZpUNZFb7gdi4iFCLVeQqwAAAABJRU5ErkJggg=="

/***/ }),

/***/ 289:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAhCAMAAABgOjJdAAAAb1BMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////8v0wLRAAAAJHRSTlMA2Q7y31A2CQe2r6xqQCTrvpiKTTnEsY2AfXhtm5rQz8NgWDtsOSikAAABHUlEQVQ4y4XU6ZaCMAwF4Ju0FCiLLIoios7Y93/GGaMsp4fl+3lPgDZtwIy5xKScovhisCBMic5BzuA8OBOlITyBbl6YvBodYC4qKfMeyaiMMOIiYfjYFmMYFTcsuRXDW0qLZbb8LpIYy5gC2abOsCbT702nDdY1KQA6QqTJiQ7K/VMHOiWphEcCDEFcnecqMRm0FcTDr7hLXLWIawj1yc80VCiJ6xg6h/jmjN+hRuJcQ7FXgejnMFWwgsNmBRwUb36FFXS+udJcj3u5O89j2EtbbXasaqWn610HmelcfOO5oLNYZ7v9+7F/x0S/9p2kx0f07Jfv+jPcnpek4N2Z8+bWGkyM1QE8YUdU1TL7dUXUjUvw/h9aOaXjy7zNf4YoIPWaw20lAAAAAElFTkSuQmCC"

/***/ }),

/***/ 290:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAOBAMAAADgeEClAAAAMFBMVEUAAAD///////////////////////////////////////////////////////////87TQQwAAAAD3RSTlMAQ/pHevV2Sz4K58wkIhOAAwfAAAAAOklEQVQI12Ng4Nj0jYGB65MaA0P/FxsGBvvPDAyP/b/YMgjpf1KEEJz13ycwMMh/ZMAghBSBhGggAwDL0RG3JiIAKAAAAABJRU5ErkJggg=="

/***/ }),

/***/ 291:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAOCAMAAADHVLbdAAAAZlBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+Vn2moAAAAIXRSTlMAmcPsXPvy78/Lo7KtdnBJQhzz2MrEt5eJgGZlVzAtEwupLckiAAAAaUlEQVQI103HRxKDMBQE0TFfmexsE+f+lwQVJURvuh6UZc4qyAkTKhrw7Ac8efEXcFdr/2ByGENctG3/dABerDvZXaDne3fFDgWj4XQzDVrW5FlI3lskY2k+dY/DHjlPCMtbqqSBEuZEbQyyD8RaD0X1AAAAAElFTkSuQmCC"

/***/ }),

/***/ 292:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAMBAMAAACdPPCPAAAAMFBMVEX///////////////////////////////////////////////////////////////9Or7hAAAAAD3RSTlMC89jrxKx4aBDq0M+NYFgkox1LAAAAQElEQVQI12NgD1GW///RyLWAIf8/BHxj2A9l/WKQ////jz6Q9ZEBSPzgAzHBLAbe+SgshCxCx3qoKb8RJiNsAwBrDlMCGZla2QAAAABJRU5ErkJggg=="

/***/ }),

/***/ 293:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 294:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAzAAAAE4CAMAAACzGuZtAAAAYFBMVEUAAAAAnuAAnuAAnuAAnuAAnuAAnuAAnuAAnuAAnuAAnuAAnuAAnuAAnuAAnuAAnuD///8BtujK6fiF0PDz+v4ApOKq3fRTwuzY7/oAsOYAqeTm9Py64/Zsye4qvOqX1/J1xS3nAAAAD3RSTlMAQMCAEGTw0KDgMFAgkLBEgTrgAAATl0lEQVR42uzcW27jMAwFUNmSH7GdaP+7HXQ+iik6ScTmAdQ+Zw8XIkVK6SFbB79Mer9tzXM/Vfilpn7O65Leoct9hV3oz2tJL7QNwsLOTHlJL7ENijB26XTe0rOtlwq71Q/pmYZThV0bc0lPksWFAxhzcbrAWyPT6fQ5kNOaHlHmCofSb+nH1rHCwYyD4wVefsgsmn0OalxT2KAc47jOKehc4cAuJQUUizAc3FQCeTF84fDGRV4gkhh5gUhi5AUiiZEXaDdu6R73Y/BpKuYv0K5PNw0V+Mecbljsw8BXQ7qq2LeE9qsy+/zwzZSuWCvwTb5SkGlg4H8WBRk8WJR1FWguyqzEwBVjMbKEdrMRDARs6atcgatmV8oQsOlg4KdHjA4GbtssxUC77JkltDulT1sF7li1/NDuYisGAoqKDNoNKjKI12R9Be4a01+lAg06U0tol312Ce16LQwEpA8VaP4+ZqlAk0HPD+2yx8nQrrfaD+0ml2QQ4HUyBBS3ytCuExho11m9hHadT/uh3Sow0C4LDAgMfBAYCBAYCBAYCBAYCBAYCBAYCBAYCBAYCBAYCBAY+MPOvSUnDkNBGF5Ct+6WfGH/u5yAMh4HcAKJAmPT3wPU4ZHir6PCLt9BwYjcQcGI3EHBiHwuT845U/AbFIzsS4meVe8CmlMwsichcsE7tKZgZEdyz6PeWut5ZAPaUjCyH9mT7MdSh8Nx6hoXo2BkN4on6cI8h4Fkh6YUjOyGJZkmWw1uAiJJh5YUjOxFIjnCcWYDBpIFDSkY2YuetFgGwwOCJyMaUjCyE5mkOQUzmKOO9KfRoyEFIzvhyL6+uTkgINSMmlEwshMDeVgGM52CQVfnVhSM7IQlxxpM54583ThRwYhcYUlTg5lNx1nBiFxh50De9RMUjMgKS7oaSGfMQHKsH281mNHdZzSmQORWB3L4t1Hs33/HPJnQzsOCifyOLo4ZIjdIJMMcTPCkL4BpfKn/UcEYfpuPKUDkC4Gkm4NBrjde2uNrQxsI5tRMxheKWdBWekWR9GUOBokkJjY+kW0jmDfW4DPZcylBXk7xZBfmYBDJ7FsvmM0EQ8aAdZ4face8oJFkV4wJqHLyzX8KGwqGfsIqnjGQ1xNJ+oR3wf3CYWNLwazeqK1gpIp80x8mY0yK/jd62VYwa880UDBSuYtDSWMbC2blmQYKRt6VyJk/BLS2tWBocYWCkVkZbU+yG1JAe5sLhhGXFIw8yPaC4YQLCkYeZIPB+IBzCkYeZIPBMOKcglmVzYLuyWvgScH4jE8YY5Ibel5XcEbBrElc6lTMTz0tmIwblGRvWjEKZkXmRwPkZ54WDG5UBl4K+EjB3Pi1W8jP/PfBAMnz3IhzkTp7XFAw7W0gGGTPMx0uHOzCoF7+sHemSW7CQBg9Qjdol1juf8vEmUkltpA/NaUiyNH7O0UPNHrWgpYHQ5j29CAMbfzKWO1fwxCmPV0IQwszjwViYoYw7elDmJiPkw0wQ5j29CEM+awTM8AMYdrTiTBrdvkAM4RpTyfChNHrP8EQpj2dCDM+TJ5hCNOeXoRJQxg5Q5j29CLMPMaV5Qxh2tOrMIoGkCFMe4YwP5l+0zRapJbEU0tatjEc35j/W5i4qdnz3/hZbZHOYSa1PEXT8+4aaBOd9c+3WKtN0OOLb2N6FWalF+STL7c98THJbiQlrr4QbK8IZpbSzRt3GLe8JUqY/6A5w8+vBPoLl/0J4kDm93cBzeSUWp6ufsqGIxlBdvNyehVmoifE0/vjnuB5AQLczG9ICtQzxhdu3ijNJexh0KAZUl776rI/QRzIvC0H3Gzi7OqXbMiMCVp283J6EUYDYWTfaaZFcF4AxiVG2Iizk1efqxYHVYwpNm/lLV/8U1ZqEkarOWd6zYYmCYvw5uV0IowBl4uEiQvXUVerb4lrUAZkJ1tIHGcG6JWeub0wib4wOz/AwrATFZMhzPHliZ4QCaO4nt0QwCxcSZpqH0/Tg0kz5qXPcHthONKDTTMWRj4Svg5hvtnBYE+9MNGzBB/Ac2l5ycTZCUTkzmw2fX9hXPY6gTAcqRo/hPkmgQ/91cJsmmVoR29wLGIxddlZC5GhMfcXxmaVMhJGUS2BhzBfbGDbmGphHMtxVGRnId5UZWeh6VzM+wuTyHgWCZOoln0I840H22vVCrMztzTGshhvarKjZ33uQIP7C8NzYiRMISJED2G+UEiHSmFWhmBjcDi5MRPLKH7F7UCYDCiMpTocD2F+4eAZMXXCOD7LRO3CLTA7ciJ985HCaENVLEOYB2bH5bdKmND2wICg+RwKZuf8KVMfKQw7qiHyEOYnLjXavd9oBsiqBd+svgLCSEJ+pjAz1bB+tjCOMHGzmjPSufNhFi6QFuWmB6taUvUpTgpE29Q+8wP8AFAYb3/HtAlVMRufn0v274XRkYjiuX0b0yWb1/0zYXhX71lKI0WBMqAwxYLk10h/yM4LKI5thqpo27GlqpgdPC85Kv0+Ke78bOWrhcnvKRyG5J0wAbSjG9HfgUqOcrAwRlfPr4y24t8eaeWn2mCxnB08v9KoykOmxOthLhfG71vV6EwijL1m6U93whz6goVRksldk+eMBB9nLQRLnGErs5PCccjcfk0HSFdcXitMWiMVSHmLGJLl5MPWw5xDFzKHhIlgnsoLZgGmzlx/oprxsIqZRPMCvmsOXKSka/qvFEavVEbJawvH16zG7ksYH6gAEGZnlr0D+3agbBL4cmiMBdlBpXurepwbC+MjvSHyK4YAV+1X35MwWlEBJIzRQl+I/Lt3trBowZo5CAayg1aN2ppm/n2F8UAAcfGPV3X5+xFG20glkDAri4f2oy6/s8jCIf/Ar6w4O4GKVP4G31YY5Att0gaWuqrL348wE5VBwiT570/5FRz4l1C4HY4hSB20FZ2YuwqjIyGS8FNMuqrL348wylARIEw46CJjdLGMe3F7OW8TBpAdpHSoEOyuwqwEUbJPMdNlXf5+hHnXJgPC7KfmWqhSoydvLxPEZuUbZGcnQMKzd24qTCKAPMf2si5/R8K82XsFCOMP/oqJpatWceE+qBA8yE4kgMUu3FSYH+ydWZadIBRFh3DoUbCZ/yyz0q68KFyuUYSE/ZmqWApu4SCCRwELp1NgTbXI35cwqdH7vDDhYnsdEz2J5Up/OeZCuhTcUyzaY6pNYcpu5u04rJ/G14v8nQkjhLI4khfGX2yvZ3M+tGP4PTIipB9LZy0s0Q6FcSgiMl7FqHqRvzthhGFPvnSJoieZ9e/Yn/96KRH5XD9OCn6NB/qq2hTGo4i1/BkSKkb+/oQ5MyYnDLEiAJer313Ig2bZ0gENHczaFCagCFtuga4Y+V8TxmySQGsVC43J3z3Eo4rLfu14OSckv9HqVpiIQlxxqxsrRv7XhJlRQvBLyRfD2btnvrmDq66MueWftJI/7tatMAoE7ELZakb+5j9RhtWGnNiSvXs24k9zMTcJIzOls4JG9SmMRimxcHDF1Yz87QsD2IWaN5IVRt+aCK8O+3iRkULyHexWmBWlrGXRxFaN/D0IA6zEbCRCmFsz/ywOOEmyirT0/5cwEqXYslcxvmrk70MY6s1Uplpu3+1PipvY/6p0/gNh4IoG2Kaqkb8TYYiy61IYhR8MYRIURbtQN/L3Iow1uSETljASf8UqvjGE+QZfmIByYsGQ9F438vciDHRuyCQrzMQXhj6RIcx3+MKAgS+QIdaN/N0IY01mLlZWGNGfMAYk/4Uw1pDdra1y5O9GGLhMn+xfE0aB5L8QBo58kiyVI38/wvhM0zuE+UeFman2w9aO/P0IEzJHGML8o8KQE2fX2pG/H2ESNz79wziEeVIY8agwnhhkm2pH/o6EUenUnx9WHsL0K4w12TOaq0f+joXR+AVLmPWeKxnCfOVpYeCyr2L26pG/I2H2dGV2+abf4wddC2MfFmbOHt9Uj/wdCaMvCrPfWainwkz6Aht+0rUw8mFhMGWqb6sf+f8DYTRx03AhFj7lM4TJ4TO9rqV+5P8PhPHEn+ZCLGLLp2th9NPCwBBrXNeN/P+BMLKNT5TTdC2Me1yYPXkN6wuRvyNh3EVhcPNzyN29W29DwvC3up8eFyYkX8XEFyJ/R8Koa8LcXq7r3bMxGhJGcy/Nkh3U5yp+fiPydyTMdFGY4/w8FGLl7+AbD6wU37AwCgRbBWF84lWMeyPydyTM1akxxyZhQxF2OnvaUkvT8WlYmAgCV0EYJL7sMG9E/n6EkZeFmcW1ZTBUokLUzSsDNiSM5K6qayoIk3iT5l+J/P0Is2ePkK22eKlJsKljrjf3yVoWZkOWTdQQJpxqvLwS+fsRJvd9NyGMu7aSWEqz+cqbGJc+gYaEAXMJTlVDmPO2PrwT+bsRxuf6VYQwm7hjRxdz+AnjBteZG7ElYSZWiJGihjDnHw/qdyJ/N8LEfHDIV5thd6Kyhmr+npkxM8TXkjCO1XiqSsIgHhv7+E7k70UYnW0kKGF2/haSNmNoYO6qRax62pIwK6fxXEUtYY4NtHwp8ncijCd2FiWECfyNFl1u8Hhh7ftPbaJcURgDAk4+C6aSMMcKjPKtyN+HMJ7cZZioNkcZQ//FKXk1dIUpQvdqwtDjg/Fwqhbn2ElUEwaLIJhRhx6EsYsgdhkmhZHM3eJX4teVOLBYpHCEXs8Jw19HdS9tPO0kKgqziTwTKtG+MEEbIchapKptEYxb3C7EJk6nAk4zznHE8/BBYfjfIsyF5TRPoqYwiCKLRyVeE8aV/TetSqqFFiaIE4w+VcafGarxwelpuYAj8ySIAHavMNR5aosssehRsBpRVxgtElSO/K8JIxadRyllRAqFD0hhUgVu9hmfBB1LaiSIU9yGT2ZHPw+fFGYXR9Suf8fiA396XR/FZH0UorIwQeRwqEWHuyifRTxaGEzinOhW+f1ws1xdFOdofJB+4plFS4mvBOkTh4v44ElhZkEyfRpjzflv7dv87cdyXYQQ1YXB0kbk71MYjU9oYahbh58pJ3GZDR88KQwiuzS1oHhFmK2NyN+lMBMO0MLA39miHd5CMFjwyaPCrGxhEJsUBrGJyN+jMCbgQIEwcOIqnnlJvID6qDDWsIWRbQqzNhH5OxTGzDhQIgxhDD9S+ptaq0eFgWcLg71JYWwTkb8/Yc58KRQG6qIvCfw9rdWzwmBhC2OnFoWBayHydyfMqS+lwsBd8iWJv8WXh4WxE1MYTj7TUNWEkS1E/t6EURYnFAuD/YIvGaS5wZeHhcFsuMJgNsWFo6sJg9hA5O9LGKORoFQYbIb3F4naCBPraBInPC0MwsQUptQYB0DWE2ZtIPJ3JYwLSMGYlM4JMtMMCi2KUQFnPC4M7MIVBmEqbXzrCWMbiPwdCeNmpOHMMdyiKMOsKGBWf3m0Z4Whr1njDLsLghXfUNWEgXs/8vciTFwDcvAm5epY1P+zKEOWKLMnj1ZDGFgdCWEOyJitkRnf0fWEke9H/lrCBCMuY5Y1gGA6vNvM4yfSUItypKPkC5zS2VHAzrxkbItJzNRJ4WNBmgwmexrTnfd3fD3y1xIG8wVjJqV2LQMKsNNh7Jkg7Gln4j6DifVLWviNVzoORbjDJZNI7RRr9QjpDNn4ziZ3Gna6cS8d/3rk/y7Mf0rwuzqZ/O4DriH14YsEo7RE32x/FFJ0G95Cvh75/2thvmGl1D+R0uJvkXL9/XD/BkF6/Y1VBrzIlvhUvR5DmEFHqOOXhJUZwgz6QRIz1yowhBn0g3p9TBlDmEE3rO+PKWMIM+iFmVgcoQpDmEEnzKaJBmYIM+gCLdpoYIYwg/Y5XwltQ32GMINWsfI764+pBg28gwGGMINGsVMzC/b/xhBm0CiLyLPjDYYwg0ZRIku0eIMhzKBRPoVpYVLMV4Ywg0bJC6PxDkOYQaNkhVnwEkOYQaMoYouOdxjCDBpFtenLEGbwhb17zVEiCMMw+sJwbQYroHE0Gve/TIGMIcoA9fmHTjhnD0+67j1O+3H2IhjGaT+2DZgTwTBSV4L5sWuPJBhGav9hLm/tsQTDSF0G8+Xrr/Z4gmGU/r4w9u3nWB54Ewzj9P3z0dtutxtJKkeCAcHAO8FAgWCgQDBQIBgoEAwUCAYKBAMFgoECwUCBYKBAMFAgGCgQDBQIBgoEAwWCgQLBQIFg4JHmGRrQaZI0QDDQBAOPNCTLBvRJMm1Al0WSbQO6TJO8NKDLKrFzCb1ekswa0GWSg3UDesxy8KkBHdY5mjegc84fxy+hzzwniwbc95qTVQN6pjAnmwbctc2BnRjoMyTGZNA/IjMmg9KIzDoZlNbI4sQy3DfN2WsDbtrkwLQfilP+uBQD98xz5mY/3L3N7xMDhQ+MTwzUZjAWyuB/PjCeW4Lrprk0s90PHxty5kQZ3LbNBa9hwBXrWRKDMii8RmZQBl1e8s5KGdy1zFV+FgP/WMxyYhoDHSa5aVAMnM1znYdj4WIHRjHQaZUoBvp7UQz096IY6O9FMdDdS8HE6jLPbZ6SwZ4/T2yxSdHMYX+e1nLIHyYyv9u5AxwGQRgKw8W2DhTY/W+7JTvAIoqJ8H93eOlrmhT4I5r8UMuAy+sYT8oxsWrSbuNdGaaSdjnH0xuYxKomZ5lyk8EcYpYvIgMcjQvFDGgoY81CZMxgVNWlA69kBuN5eZZe9sIxEwNJ0U36sqCVjQaPty7Fs9xlC65aFuB5VDUEafMB2Q2+mLS4RegAAAAASUVORK5CYII="

/***/ }),

/***/ 419:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _header = __webpack_require__(133);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _goToTop = __webpack_require__(132);
	
	var _goToTop2 = _interopRequireDefault(_goToTop);
	
	var _footerComponents = __webpack_require__(131);
	
	var _footerComponents2 = _interopRequireDefault(_footerComponents);
	
	__webpack_require__(254);
	
	var _favicon = __webpack_require__(295);
	
	var _favicon2 = _interopRequireDefault(_favicon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TemplateWrapper = function TemplateWrapper(_ref) {
		var children = _ref.children,
		    data = _ref.data;
	
		var lang = 'es';
		if ("undefined" != typeof window) {
			lang = window.location.pathname.split('/')[1];
		}
	
		var dataProducts = data.allBicenturyNavbar.edges.map(function (x) {
			return x;
		}).filter(function (x) {
			return x.node.lang === lang;
		})[0].node;
		var translations = data.allBicenturyTranslations.edges.map(function (x) {
			return x;
		}).filter(function (x) {
			return x.node.lang === lang;
		})[0].node;
	
		return _react2.default.createElement(
			'div',
			null,
			_react2.default.createElement(
				_reactHelmet2.default,
				{
					title: 'Gatsby Default Starter',
					meta: [{ name: 'description', content: 'Bicentury' }, { name: 'keywords', content: 'Bicentury' }] },
				_react2.default.createElement('link', { 'data-is-minisite-asset': 'true', href: 'https://fonts.googleapis.com/css?family=Montserrat:200,300,400,500,600,700|Oswald:300,500,700|Playfair+Display', rel: 'stylesheet' }),
				_react2.default.createElement('link', { 'data-is-minisite-asset': 'true', rel: 'shortcut icon', type: 'image/png', href: _favicon2.default })
			),
			_react2.default.createElement(_header2.default, { lang: lang,
				data: dataProducts,
				translations: translations
			}),
			_react2.default.createElement(
				'main',
				null,
				children()
			),
			_react2.default.createElement(_footerComponents2.default, {
				lang: lang,
				translations: translations,
				dataProducts: dataProducts
			}),
			_react2.default.createElement(_goToTop2.default, null),
			_react2.default.createElement('script', { 'data-is-minisite-asset': 'true', src: 'https://ajax.googleapis.com/ajax/libs/jquery/2.2.2/jquery.min.js' })
		);
	};
	
	TemplateWrapper.propTypes = {
		children: _propTypes2.default.node
	};
	
	exports.default = TemplateWrapper;
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 295:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAIAAAD8GO2jAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyRpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoTWFjaW50b3NoKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDowNjZFMzNFRkE5NTUxMUU4QURBNkU2OUZCNEVFQzlFNyIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDowNjZFMzNGMEE5NTUxMUU4QURBNkU2OUZCNEVFQzlFNyI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjA2NkUzM0VEQTk1NTExRThBREE2RTY5RkI0RUVDOUU3IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjA2NkUzM0VFQTk1NTExRThBREE2RTY5RkI0RUVDOUU3Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+6EvOTgAAAkFJREFUeNrslbtvE0EQh3fvafsusZEfQcIEJRgFZMwjoDSRaOgigStMg0KBkChRCkoKlH8DehoaCpSCApoICkgoACFhEjsQRY4TO3f2PfbFrB2RGEGBIAXSTXEa7Wjm25vfzB1Gj1bQQZqCDtgiQASIAP8hACPEBOJCOj3T9mIqRj5DHpcxXZFoDctD8Zsq/ZSfokxkLc1nwgkYUvAgoMvGM8b1MQtSnta6HSpWHIq2CYqrkuRS6YDBJVQFmYpk+BzFeg4R8gkVDTyVNb522dI6BV/eAZXv7gIcMltKnk8bb5rhbMGqQnWEb59JIh1Dws1Ssu6ztKXeKiVDIuYmU9cK9jeHtBGCK09kzPIJO2Wr1UaAdbUZcpeI/hvsA4R8PGMWkvpOwFtEWIZy56T92aUk5PcnU+fSxvSIeWU0AT0ZPWQUU8aqw4o5s+bSS4dj8xdS9Q6dypmqpswcjb9thjvQahUPiszFEUt1Qr5Q7V7MGNM5I29pz+pezaFn08bHFnED3iHiwVJ7rUMdxl9vBlsBn8nHgb3hsfl37XuL248vZ1c7tF73+v0Z1CCmLqx5N47blVNDDz+5X1w6ElfnTg8vbgaV542rxxIvN3xIsnX8oUVAnolh7VUjqIwllrfCF+t+XlcIEV0ilhshlPohPt77o0HLQPpQQNsQh0HCUjooiWFUhExQej6cg55U7KZQLg97c1UuDkNXnrx3kPVLwN9uFEYeQ4SjIW3/7Gr/bMVgucze+IroWxQBIkAE+FP7LsAAkl77L3TowOMAAAAASUVORK5CYII="

/***/ }),

/***/ 25:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.OutboundLink = undefined;
	
	var _extends2 = __webpack_require__(73);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function OutboundLink(props) {
	  return _react2.default.createElement("a", (0, _extends3.default)({}, props, {
	    onClick: function onClick(e) {
	      if (typeof props.onClick === "function") {
	        props.onClick();
	      }
	      var redirect = true;
	      if (e.button !== 0 || e.altKey || e.ctrlKey || e.metaKey || e.shiftKey || e.defaultPrevented) {
	        redirect = false;
	      }
	      if (props.target && props.target.toLowerCase() !== "_self") {
	        redirect = false;
	      }
	      if (window.ga) {
	        window.ga("send", "event", {
	          eventCategory: "Outbound Link",
	          eventAction: "click",
	          eventLabel: props.href,
	          transport: redirect ? "beacon" : "",
	          hitCallback: function hitCallback() {
	            if (redirect) {
	              document.location = props.href;
	            }
	          }
	        });
	      } else {
	        if (redirect) {
	          document.location = props.href;
	        }
	      }
	
	      return false;
	    }
	  }));
	}
	
	OutboundLink.propTypes = {
	  href: _propTypes2.default.string,
	  target: _propTypes2.default.string,
	  onClick: _propTypes2.default.func
	};
	
	exports.OutboundLink = OutboundLink;

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-a33ea10202ff531ed0b2.js